import { render } from "./login-header.vue?vue&type=template&id=6ea0dfdf&scoped=true"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"

import "./login-header.vue?vue&type=style&index=0&id=6ea0dfdf&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea0dfdf"]])

export default __exports__